import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { IconButton, AppBar, Toolbar } from '@material-ui/core';
import { Menu as MenuIcon } from '@material-ui/icons';
//
import DashboardNavbar from './DashboardNavbar'; // UNCOMMENTED - Show navbar only on dashboard
import DashboardSidebar from './DashboardSidebar';
import FloatingChat from 'src/pages/dashboard/ChatModuleSignwise/FloatingChatButton';
import HelpDeskChatButton from 'src/pages/dashboard/ChatModuleSignwise/HelpDeskChatButton';
import { Box } from '@material-ui/core';
import { MHidden } from '../../components/@material-extend';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  height: '100vh',
  overflow: 'hidden',
  width: '100%',
  margin: 0,
  padding: 0
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100vh',
  margin: 0,
  paddingTop: APP_BAR_MOBILE + 24, // Mobile header height + padding
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: 30, // No mobile header on desktop
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

const MobileHeaderStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.up('lg')]: {
    display: 'none'
  }
}));

// ----------------------------------------------------------------------

const HELP_DESK_USER_ID = 39

function getLoggedInUserId() {
  try {
    const raw = localStorage.getItem('user')
    if (!raw || raw === 'null' || raw === 'undefined') return null
    return Number(JSON.parse(raw)?.user_id)
  } catch (e) {
    return null
  }
}

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const isHelpDesk = getLoggedInUserId() === HELP_DESK_USER_ID;

  return (
    <RootStyle>
      {/* Mobile Header with Hamburger Menu */}
      <MobileHeaderStyle>
        <Toolbar sx={{ minHeight: APP_BAR_MOBILE }}>
          <MHidden width="lgUp">
            <IconButton 
              onClick={() => setOpen(true)} 
              sx={{ mr: 1, color: 'text.primary' }}
            >
              <MenuIcon />
            </IconButton>
          </MHidden>
        </Toolbar>
      </MobileHeaderStyle>

      <DashboardSidebar 
        isOpenSidebar={open} 
        onCloseSidebar={() => setOpen(false)} 
        isCollapsed={isCollapsed}
        onToggleCollapse={() => setIsCollapsed(!isCollapsed)}
      />
      <MainStyle>
        <Outlet />
      </MainStyle>
      {isHelpDesk ? <FloatingChat /> : <HelpDeskChatButton />}
    </RootStyle>
  );
}


// import { useState } from 'react';
// import { Outlet, useLocation } from 'react-router-dom';
// // material
// import { experimentalStyled as styled } from '@material-ui/core/styles';
// //
// import DashboardNavbar from './DashboardNavbar'; // UNCOMMENTED - Show navbar only on dashboard
// import DashboardSidebar from './DashboardSidebar';

// // ----------------------------------------------------------------------

// const APP_BAR_MOBILE = 64;
// const APP_BAR_DESKTOP = 92;

// const RootStyle = styled('div')({
//   display: 'flex',
//   minHeight: '100%',
//   overflow: 'hidden'
// });

// const MainStyle = styled('div')(({ theme, showNavbar }) => ({
//   flexGrow: 1,
//   overflow: 'auto',
//   minHeight: '100%',
//   paddingTop: showNavbar ? APP_BAR_MOBILE + 2 : 30, // Conditional padding based on navbar
//   paddingBottom: theme.spacing(10),
//   [theme.breakpoints.up('lg')]: {
//     paddingTop: showNavbar ? APP_BAR_DESKTOP + 2 : 30, // Conditional padding based on navbar
//     paddingLeft: theme.spacing(2),
//     paddingRight: theme.spacing(2)
//   }
// }));

// // ----------------------------------------------------------------------

// export default function DashboardLayout() {
//   const [open, setOpen] = useState(false);
//   const location = useLocation();
  
//   // Show navbar only on dashboard app page (/dashboard/app)
//   const showNavbar = location.pathname === '/dashboard/app';

//   return (
//     <RootStyle>
//       {showNavbar && <DashboardNavbar onOpenSidebar={() => setOpen(true)} />}
//       <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
//       <MainStyle showNavbar={showNavbar}>
//         <Outlet />
//       </MainStyle>
//     </RootStyle>
//   );
// }
